import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

import { getFromBreakpoint } from '../../styles/breakpoints';

export const useStyles = makeStyles()((theme) => ({
	imageWrapper: {
		position: 'relative',
		minHeight: '257px',
		maxHeight: '257px',

		[getFromBreakpoint('md')]: {
			minHeight: '282px',
			maxHeight: '282px',
		},
	},
	imageContainer: {
		width: '100%',

		/** Stretch the images to cover the full width */
		'& img': {
			objectFit: 'cover',
		},
	},
	imageSliderContainer: {
		position: 'relative',

		'.slider-control-centerright': {
			marginRight: theme.spacing.xxsmall,
		},
		'.slider-control-centerleft': {
			marginLeft: theme.spacing.xxsmall,
		},
	},
	roomTitle: {
		wordBreak: 'break-word',
	},
	imageCountContainer: {
		zIndex: theme.zIndex.lifted,
		position: 'absolute',
		bottom: theme.spacing.small,
		right: theme.spacing.small,
	},
	roomInfoModalContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.small,

		[getFromBreakpoint('md')]: {
			gap: theme.spacing.medium,
		},
	},
	attributeContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.xsmall,

		[getFromBreakpoint('md')]: {
			gap: theme.spacing.small,
		},
	},
	attributesLists: {
		display: 'grid',
		gridTemplateColumns: '1fr',
		gap: 0,

		[getFromBreakpoint('md')]: {
			gridTemplateColumns: '1fr 1fr',
			gap: theme.spacing.small,
		},
	},
	attributesList: {
		/** Temp styling until the attributes are categorized */
		marginBottom: 0,

		/** Temp styling until the attributes are categorized */
		':first-of-type': {
			marginBottom: theme.spacing.xxsmall,
		},
	},
	topContainer: {
		display: 'grid',
		gridTemplateColumns: '1fr',
		gap: theme.spacing.xsmall,

		[getFromBreakpoint('md')]: {
			gridTemplateColumns: '1fr 1fr',
			gap: theme.spacing.small,
		},
	},
	roomDetails: {
		display: 'flex',

		[getFromBreakpoint('md')]: {
			flexDirection: 'column',
			justifyContent: 'center',
		},
	},
	disclaimer: {
		color: theme.disclaimer.color,
		font: theme.disclaimer.font,
	},
}));
